<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    show?: boolean
    message: string | string[]
    size?: 'default' | 'small'
    dismissible?: boolean
  }>(),
  {
    show: undefined,
    size: 'default',
    dismissible: false,
  },
)

const lifecycleStore = useLifecycleStore()

// Default to lifecycleStore.attemptedSubmit for showing the message
const show = computed(() => {
  if (typeof props.show === 'boolean') return props.show
  return lifecycleStore.attemptedSubmit
})

const messages = computed(() => {
  if (typeof props.message !== 'string') return props.message
  if (props.message.length === 0) return []
  return [props.message]
})

const visible = computed(() => {
  if (messages.value.length === 0) return false
  if (!show.value) return false

  return true
})
</script>

<template>
  <Alert :show="visible" theme="warning" v-bind="{ size, dismissible }">
    <p v-for="message in messages" class="first:mt-0 last:mb-0">{{ message }}</p>
  </Alert>
</template>
